import styled, { css, keyframes } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexColumnDiv, FlexRow } from "./common.styles";
import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
import CheckIcon from "@mui/icons-material/Check";
import LockIcon from "@mui/icons-material/Lock";
import WarningIcon from "@mui/icons-material/Warning";
import { SemiBoldText } from "./HXDesktopPage.styles";
import AddIcon from "@mui/icons-material/Add";
import { fontWeights } from "healthex-common/weights";
import { LighterText } from "./HXMobilePage.styles";
import { fontSizes } from "healthex-common/sizes";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
export const LocationCard = styled(FlexColumn) `
    width: 100%;
    padding: 16px;
    gap: 16px;
    border: 2px solid ${colors.blue_10};
    box-sizing: border-box;
    background-color: ${colors.white_background};

    ${(props) => !props.isFirst && `border-top: none;`}
    ${(props) => props.isError && `padding: 16px 2px 16px 16px;`}

    border-radius: ${(props) => {
    if (props.isFirst && props.isLast)
        return "8px";
    if (props.isFirst)
        return "8px 8px 0 0";
    if (props.isLast)
        return "0 0 8px 8px";
    return "0";
}};
`;
export const LocationHeader = styled(FlexRow) `
    width: 100%;
    gap: 12px;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
`;
export const LocationLeftContent = styled(FlexRow) `
    flex: 1;
    gap: 16px;
    align-items: center;
    min-width: 0;
`;
export const LocationLogoContainer = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 4px;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid ${colors.black_12};
    box-sizing: border-box;
`;
export const LocationLogo = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
export const LocationFallbackIcon = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
    background: linear-gradient(180deg, rgba(29, 98, 174, 0.28) 0%, rgba(29, 98, 174, 0.4) 100%);
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
    font-size: 16px;
    color: ${colors.white_main};
    text-transform: uppercase;
`;
export const LocationInfoContainer = styled(FlexColumn) `
    flex: 1;
    gap: 4px;
    min-width: 0;
    justify-content: center;
`;
export const LocationName = styled(SemiBoldText) `
    color: ${(props) => (props.status === DocumentRetrievalLocationStatus.SKIPPED ? colors.black_30 : colors.black_main)};
    text-align: left;
    width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
`;
export const BaseLocationIcon = css `
    width: 20px;
    height: 20px;
    opacity: 0.7;
    color: ${colors.navy_main};
`;
export const Check = styled(CheckIcon) `
    ${BaseLocationIcon}
    aspect-ratio: 1/1;
`;
export const Error = styled(LockIcon) `
    ${BaseLocationIcon}
    flex-shrink: 0;
`;
export const ErrorContainer = styled(FlexColumnDiv) `
    height: 48px;
    width: 48px;
    justify-content: center;
    align-items: center;
`;
export const ProviderForwardIcon = styled(ArrowForwardIosIcon) `
    ${BaseLocationIcon}
    aspect-ratio: 1/1;
`;
export const LocationsListContainer = styled(FlexColumn) `
    width: 100%;
    box-sizing: border-box;
    gap: 16px;
    flex: 1 0 0;
`;
export const SectionContainer = styled(FlexColumn) `
    opacity: ${(props) => (props.shouldDelay ? 0 : 1)};

    ${(props) => props.shouldDelay &&
    `
            animation: fadeInSection 300ms ease-in forwards;
            animation-delay: 500ms;
        `}

    @keyframes fadeInSection {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
export const SectionLabel = styled.span `
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    line-height: normal;
`;
export const ProviderText = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    letter-spacing: normal;
    text-align: left;
`;
const fadeInCard = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
export const AnimatedCardWrapper = styled.div `
    width: 100%;

    ${(props) => props.shouldDelay && props.animate
    ? css `
                  opacity: 0;
                  animation: ${fadeInCard} 300ms ease-in forwards;
                  animation-delay: 500ms;
              `
    : css `
                  opacity: 1;
              `}
`;
export const AddProviderContainer = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 6px;
    background: ${colors.blue_10};
    border: 1px solid ${colors.blue_10};
    opacity: 0.8;
    align-self: center;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
`;
export const AddProviderIcon = styled(AddIcon) `
    width: 24px;
    height: 24px;
`;
export const ErrorIconContainer = styled.div `
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background-color: ${colors.sunset_12};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const Warning = styled(WarningIcon) `
    width: 40px;
    height: 40px;
    color: ${colors.sunset_main};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }
`;
